export default __webpack_public_path__ + "static/media/profileAvatar.0770861d.svg";